import React, {Component} from "react";
import {Button, CardBody} from "reactstrap";
import {predefinedButtonFilter, predefinedInvoiceTypes} from "../../invoice/PredefinedInvoiceTypes";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {deepCopyObject} from "../../../helper/helper";
import Select from "../../../local_node_modules/react-select";

class PredefinedSelectionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPredefined: [],
            outPredefined: [],
            newPreDefined: [],
            openEdit: false,
            type: null,
        }
        this.renderSinglePredefined = this.renderSinglePredefined.bind(this);
        this.renderOutPredefined = this.renderOutPredefined.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
    }

    fetchData(){
        let self = this;
        let selectedPredefined = [];
        let outPredefined = [];
        let newPreDefined = [];
        let params = {
            url: `/customer/fetchPredefinedInvoiceTypes`,
            method: 'post',
        };
        request(params)
            .then(function (response) {
                newPreDefined = response.data;
                predefinedInvoiceTypes.map(predefined => {
                        let prefix = self.state.type === "EFATURA" ? "ef" : (self.state.type === "EARSIV" ? "ea" : "eb");
                        if(predefined.gibType === self.state.type){
                            if (response.data[prefix + "_" + predefined.value]) {
                                selectedPredefined.push(predefined);
                            }else if(response.data[prefix + "_" + predefined.value] !== undefined && response.data[prefix + "_" + predefined.value] !== null) {
                                outPredefined.push(predefined);
                            }
                        }
                });
                self.setState({newPreDefined,selectedPredefined,outPredefined,openEdit: true});
            });
    }

    renderSinglePredefined(predefined) {
        return <Button className="PreDefinedEdit vazgec predefined" key={predefined.value} onClick={() => this.onDelete(predefined)}>{predefined.label}</Button>;
    };

    renderOutPredefined(predefined) {
        return <Button className="OutPreDefinedEdit ekle predefined" key={predefined.value} onClick={() => this.onAdd(predefined)}>{predefined.label}</Button>;
    };

    onSave() {
        let self = this;
        let newPreDefined = deepCopyObject(self.state.newPreDefined);

        let params = {
            url: `/customer/savePredefinedInvoiceTypes`,
            method: 'post',
            data: newPreDefined,
        };
        request(params)
            .then(response => {
                Alert.success("Kayıt işlemi başarıyla gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000,
                    html:false
                });
                self.setState({openEdit: false});
        })

    };

    onDelete(predefined){
        let self = this;
        let selectedPredefined = deepCopyObject(self.state.selectedPredefined);
        let outPredefined = deepCopyObject(self.state.outPredefined);
        let newPreDefined = deepCopyObject(self.state.newPreDefined);

        let prefix = predefined.gibType === "EFATURA" ? "ef" : (predefined.gibType === "EARSIV" ? "ea" : "eb");
        newPreDefined[prefix+"_"+predefined.value] = false;

        selectedPredefined.splice(selectedPredefined.findIndex( defined => defined.value === predefined.value),1);
        outPredefined.push(predefined);

        self.setState({newPreDefined,selectedPredefined,outPredefined});
    }

    onAdd(predefined){
        let self = this;
        let selectedPredefined = deepCopyObject(self.state.selectedPredefined);
        let outPredefined = deepCopyObject(self.state.outPredefined);
        let newPreDefined = deepCopyObject(self.state.newPreDefined);

        let prefix = predefined.gibType === "EFATURA" ? "ef" : (predefined.gibType === "EARSIV" ? "ea" : "eb");
        newPreDefined[prefix+"_"+predefined.value] = true;

        outPredefined.splice(outPredefined.findIndex( defined => defined.value === predefined.value),1);
        selectedPredefined.push(predefined);

        self.setState({newPreDefined,selectedPredefined,outPredefined});
    }

    renderOptions(){
        let options = [];
        if(this.props.isEFatura){
            options.push({label: "E-Fatura", value: "EFATURA"})
        }
        if(this.props.isEArsiv){
            options.push({label: "E-Arşiv Fatura", value: "EARSIV"});
        }
        if(this.props.isEbelge){
            options.push({label: "E-Arşiv Belge", value: "EBELGE"});
        }
        return options;
    }

    render() {
        return(
            <div className={'FormRenk'}>
                {!this.state.openEdit &&
                <div className={"row"}>
                    <div className={"col-md-3"}>
                        <label style={{fontSize: "13px", fontWeight: 'bold'}}>Düzenlemek istediğiniz Hizmeti
                            Seçiniz: </label>
                    </div>
                    <div className={"col-md-4"} style={{paddingRight: '100px'}}>
                        <Select
                            clearable={false}
                            className="select-control"
                            value={this.state.type !== undefined && this.state.type}
                            placeholder="Seçiniz..."
                            onChange={(e) => this.setState({type: e.value})}
                            options={this.renderOptions()}
                        />
                    </div>

                    <div className={"col-md-1"}>
                        <Button className={"duzenle"}
                                disabled={!this.state.type}
                                onClick={() => {
                                    this.fetchData()
                                }}>
                            <i style={{	fontSize: "13px"}} className="fas fa-edit"> Düzenle</i>
                        </Button>
                    </div>
                </div>}

                {this.state.openEdit &&
                <div style={{alignItems: "center", justifyContent: "center"}} className={"row"}>
                    <div className={"col-md-9"}>
                        <div style={{paddingTop: '5px'}} className="row">
                            <div style={{border: '1px solid rgba(151, 151, 151, 0.65)'}} className="col-sm-5">
                                <div style={{textAlign: "center"}}>
                                    <label style={{paddingTop: '10px', fontSize: "17px", fontWeight: 'bold'}}>Havuzunuzdaki Öntanımlı
                                        Faturalarınız: </label>
                                </div>
                                {
                                    this.state.selectedPredefined.map(predefined => {
                                        return this.renderSinglePredefined(predefined)
                                    })
                                }
                            </div>

                            <div className="col-sm-1"></div>

                            <div style={{border: '1px solid rgba(151, 151, 151, 0.65)'}} className="col-sm-5">
                                <div style={{textAlign: "center"}}>
                                    <label style={{paddingTop: '10px', fontSize: "17px", fontWeight: 'bold'}}>Görünecek Öntanımlı
                                        Faturalar: </label>
                                </div>
                                {
                                    this.state.outPredefined.map(predefined => {
                                        return this.renderOutPredefined(predefined)
                                    })
                                }
                            </div>

                        </div>
                    </div>

                    <div className="col-md-2 text-center">
                        <Button  style={{marginRight: '3px', fontSize: "13px", backgroundColor: "#bdbdbd", color: "black"}}
                                onClick={() => {
                                    this.setState({openEdit: false})
                                }}>
                            <i className="fas fa-angle-double-left"></i> Geri Dön
                        </Button>

                        <Button style={{fontSize: "13px", color: "white", backgroundColor: " #04AA6D"}}
                                onClick={() => {
                                    this.onSave()
                                }}>
                            <i className="fas fa-plus-circle"></i> Kaydet
                        </Button>

                    </div>

                </div>}
            </div>
        )
    }

} export default PredefinedSelectionModal;